import { createContext, useState, useEffect } from 'react'
import { useCountings } from 'hooks/useCountings/useCountings'
export const CompaniesContext = createContext()



export const CompaniesProvider = ({ children }) => {
    const { companies, setCompanies } = useCountings()

    return (
        <CompaniesContext.Provider value={{ companies: companies, setCompanies }}>
            {children}
        </CompaniesContext.Provider>
    )
}